import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { SimplePage } from '@cp-mx/common';
import { fetchCookiePolicy } from './CookiePolicySlice';
import { CookiePolicyContentSelector } from './CookiePolicyContentSelector';

export function useCookiePolicy(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchCookiePolicy, CookiePolicyContentSelector);
}
